<script setup lang="ts">
withDefaults(defineProps<{
  density?: 'default' | 'comfortable' | 'compact'
  nav?: boolean
  lines?: false | 'one' | 'two' | 'three'
  elevation?: number | string
  rounded?: boolean | string
  minWidth?: number | string
}>(), {
  density: 'default',
})
</script>

<template>
  <div
    class="m-list"
    :class="[
      `m-list--${density}`,
      {
        'm-list--nav': nav,
        'm-list--rounded': rounded,
        [`m-list--elevation-${elevation}`]: elevation,
      }
    ]"
    :style="{
      minWidth: minWidth ? (typeof minWidth === 'number' ? `${minWidth}px` : minWidth) : undefined,
    }"
    role="list"
  >
    <slot />
  </div>
</template>

<style scoped>
.m-list {
  padding: var(--m-space-2) 0;
  background: var(--m-surface);
}
.m-list--nav {
  padding: var(--m-space-2);
}
.m-list--rounded { border-radius: var(--m-radius); }
.m-list--elevation-1 { box-shadow: var(--m-shadow-sm); }
.m-list--elevation-2 { box-shadow: var(--m-shadow); }
.m-list--elevation-3 { box-shadow: var(--m-shadow-md); }
.m-list--elevation-4,
.m-list--elevation-5,
.m-list--elevation-6,
.m-list--elevation-8 { box-shadow: var(--m-shadow-lg); }
</style>
